module.exports = __webpack_public_path__ + "static/media/project_6.a1d8397e.png";